@if (!isProcessingBySender) {
    <div fxLayout="column" fxLayoutAlign="start start" class="w-100 bc-mono-white radius-16 p-24">
        <div class="t2-semi-bold">{{ 'i18n_lib_stepperLabel_refundCommonInfo' | translate }}</div>
        <ng-container [ngTemplateOutlet]="formTemplate"></ng-container>
    </div>
}

@if (isProcessingBySender) {
    <mat-expansion-panel
        [hideToggle]="Spinner.isShown('initForms')"
        [disabled]="Spinner.isShown('initForms')">
        <mat-expansion-panel-header class="w-100"
                                    [class.loading]="Spinner.isShown('initForms')"
                                    fxLayout="start space-between">
            <mat-panel-title class="no-wrap t2-semi-bold">
                {{ 'i18n_lib_stepperLabel_refundCommonInfo' | translate }}
            </mat-panel-title>
            @if (Spinner.isShown('initForms')) {
                <mat-panel-description fxLayoutAlign="end">
                    <ui-kit-spinner [diameter]="16" [strokeWidth]="3" spinnerIds="initForms"/>
                </mat-panel-description>
            }
        </mat-expansion-panel-header>
        <ng-container [ngTemplateOutlet]="formTemplate"></ng-container>
    </mat-expansion-panel>
}

<ng-template #formTemplate>
    @if (form) {
        <form [fxHide]="Spinner.isShown('initForms')" [formGroup]="form" fxLayout="column"
              fxLayoutAlign="start start"
              class="w-824 mt-16"
              (submit)="submit()">
            @if (!isProcessingBySender) {
                <div class="grid-form-container mt-24">
                    @if (form.controls.refundType) {
                        <af-dictionary-selector dictionaryName="refund_type"
                                                class="min-max-w-400"
                                                [control]="form.controls.refundType"
                                                [excludeFromDictionary]="excludedRefundTypes"
                                                [disabled]="isRefundTypeDisabled"
                                                [predefinedValue]="refund?.type"
                                                label="i18n_af_labelRefundType"
                                                placeholder="i18n_af_placeholderRefundType"/>
                    }
                    @if (form.controls.transactions) {
                        <div fxLayout="column"
                             fxLayoutAlign="start start"
                             class="min-max-w-400">
                            <div class="t5 c-primary-gray-600">
                                {{ 'i18n_af_labelTransaction' | translate }} {{ form.controls.transactions.hasValidator(Validators.required) ? '*' : '' }}
                            </div>
                            <mat-form-field class="w-100 mt-4">
                                <input matInput
                                       readonly
                                       [placeholder]="'i18n_af_placeholderSelectTransaction' | translate"
                                       [formControl]="form.controls.transactionDisplayValue"
                                       (click)="openTransactionsDialog()">
                                @if (Spinner.isShown('transactions')) {
                                    <div matSuffix class="mr-16">
                                        <ui-kit-spinner spinnerIds="transactions"
                                                        [diameter]="16"
                                                        [strokeWidth]="3"/>
                                    </div>
                                } @else {
                                <ui-kit-svg matSuffix
                                            class="i-16 mr-16 pointer c-primary-gray-600"
                                            name="ic_arrow_down"/>
                                }
                                @if (form.controls.transactionDisplayValue.hasError('required')) {
                                    <mat-error class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }
                    @if (form.controls.grounds) {
                        <af-dictionary-selector dictionaryName="refund_grounds"
                                                class="min-max-w-400"
                                                [isDependentDictionary]="true"
                                                [control]="form.controls.grounds"
                                                [parentDictionaryFormControl]="form.controls.refundType"
                                                label="i18n_af_labelRefundGrounds"
                                                placeholder="i18n_af_placeholderRefundGrounds"/>
                    }
                    @if (form.controls.prosecutorOfficeBin) {
                        <af-dictionary-selector dictionaryName="bin"
                                                class="min-max-w-400"
                                                [predefinedValue]="prosecutionBin"
                                                [filterDictionaryBy]="[prosecutionBin]"
                                                [control]="form.controls.prosecutorOfficeBin"
                                                label="i18n_af_labelProsecutorOfficeBin"
                                                placeholder="i18n_af_placeholderProsecutorOfficeBin"/>
                    }
                    @if (form.controls.documentNumber) {
                        <div fxLayout="column"
                             fxLayoutAlign="start start"
                             class="min-max-w-400">
                            <div class="t5 c-primary-gray-600">
                                {{ 'i18n_af_labelDocumentNumber' | translate }} {{ form.controls.documentNumber.hasValidator(Validators.required) ? '*' : '' }}
                            </div>
                            <mat-form-field class="w-100 mt-4">
                                <input matInput
                                       [placeholder]="'i18n_af_placeholderEnterDocumentNumber' | translate"
                                       [formControl]="form.controls.documentNumber">
                                @if (form.controls.documentNumber.hasError('required')) {
                                    <mat-error class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }

                    @if (form.controls.documentDate) {
                        <af-date-picker-field labelTranslationKey="i18n_af_labelDateFrom"
                                              placeholderTranslationKey="i18n_af_placeholderDate"
                                              [form]="form.controls.documentDate"
                                              [supportedDateFormat]="['DDMMYYYY', 'DD.MM.YYYY']"
                                              [dateFormats]="DATE_TIME_FORMATS"/>
                    }
                    @if (form.controls.refundAmount) {
                        <div fxLayout="column" fxLayoutAlign="start start"
                             class="min-max-w-400">
                            <div
                                class="t5 c-primary-gray-600">{{ ('i18n_af_labelRefundAmount') | translate }} {{ form.controls.refundAmount.hasValidator(Validators.required) ? '*' : '' }}
                            </div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.controls.refundAmount.value">
                                <input matInput
                                       commonsTiynTengeInput
                                       [formControl]="form.controls.refundAmount"
                                       [placeholder]="'i18n_af_placeholderRefundAmount' | translate"
                                       name="amount"/>
                                @if (form.controls.refundAmount.hasError('required')) {
                                    <mat-error class="c-secondary-red-900 t3">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }
                    @if (form.controls.currency) {
                        <af-dictionary-selector dictionaryName="currency"
                                                class="w-100"
                                                [control]="form.controls.currency"
                                                label="i18n_af_labelCurrency"
                                                placeholder="i18n_af_placeholderCurrency"/>
                    }

                    @if (form.controls.refundAmountInKzt) {
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                            <div class="t5 c-primary-gray-600">
                                {{ ('i18n_af_labelRefundTransactionAmountInKzt') | translate }} {{
                                    form.controls.refundAmountInKzt.hasValidator(Validators.required) ? '*' : ''
                                }}
                            </div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.controls.refundAmountInKzt.value">
                                <input matInput
                                       commonsTiynTengeInput
                                       [formControl]="form.controls.refundAmountInKzt"
                                       [placeholder]="'i18n_af_placeholderRefundTransactionAmount' | translate"
                                       name="amount"/>
                                @if (form.controls.refundAmountInKzt.hasError('required')) {
                                    <mat-error class="c-secondary-red-900 t3">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }

                    @if (form.controls.resolutionNumber) {
                        <div fxLayout="column" fxLayoutAlign="start start"
                             class="min-max-w-400">
                            <div
                                class="t5 c-primary-gray-600">{{ 'i18n_af_labelResolutionNumber' | translate }} {{
                                    form.controls.resolutionNumber.hasValidator(Validators.required) ? '*' : ''
                                }}
                            </div>
                            <mat-form-field class="w-100 mt-4">
                                <input matInput
                                       [placeholder]="'i18n_af_placeholderEnterResolutionNumber' | translate"
                                       [formControl]="form.controls.resolutionNumber">
                                @if (form.controls.resolutionNumber.hasError('required')) {
                                    <mat-error class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }

                    @if (form.controls.resolutionDate) {
                        <af-date-picker-field labelTranslationKey="i18n_af_labelRefundResolutionDate"
                                              placeholderTranslationKey="i18n_af_placeholderResolutionDate"
                                              [form]="form.controls.resolutionDate"
                                              [supportedDateFormat]="['DDMMYYYY', 'DD.MM.YYYY']"
                                              [dateFormats]="DATE_TIME_FORMATS"/>
                    }
                    @if (form.controls.lawNumber) {
                        <div fxLayout="column" fxLayoutAlign="start start"
                             class="min-max-w-400">
                            <div
                                class="t5 c-primary-gray-600">{{ 'i18n_af_labelLawArticleReason' | translate }} {{
                                    form.controls.lawNumber.hasValidator(Validators.required) ? '*' : ''
                                }}
                            </div>
                            <mat-form-field class="w-100 mt-4">
                                <input matInput
                                       [placeholder]="'i18n_af_placeholderEnterLawArticleReason' | translate"
                                       [formControl]="form.controls.lawNumber">
                                @if (form.controls.lawNumber.hasError('required')) {
                                    <mat-error class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }

                    @if (form.controls.lawDate) {
                        <af-date-picker-field labelTranslationKey="i18n_af_labelDateFrom"
                                              placeholderTranslationKey="i18n_af_placeholderDate"
                                              [form]="form.controls.lawDate"
                                              [supportedDateFormat]="['DDMMYYYY', 'DD.MM.YYYY']"
                                              [dateFormats]="DATE_TIME_FORMATS"/>
                    }

                    @if (form.controls.prosecutorJobTitle) {
                        <div fxLayout="column" fxLayoutAlign="start start"
                             class="min-max-w-400">
                            <div
                                class="t5 c-primary-gray-600">{{ 'i18n_af_labelProsecutorJobTitle' | translate }} {{
                                    form.controls.prosecutorJobTitle.hasValidator(Validators.required) ? '*' : ''
                                }}
                            </div>
                            <mat-form-field class="w-100 mt-4">
                                <input matInput
                                       [placeholder]="'i18n_af_placeholderEnterJobTitle' | translate"
                                       [formControl]="form.controls.prosecutorJobTitle">
                                @if (form.controls.prosecutorJobTitle.hasError('required')) {
                                    <mat-error class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }

                    @if (form.controls.prosecutorFullName) {
                        <div fxLayout="column" fxLayoutAlign="start start"
                             class="min-max-w-400">
                            <div
                                class="t5 c-primary-gray-600">{{ 'i18n_af_labelProsecutorFullName' | translate }} {{
                                    form.controls.prosecutorFullName.hasValidator(Validators.required) ? '*' : ''
                                }}
                            </div>
                            <mat-form-field class="w-100 mt-4">
                                <input matInput
                                       [placeholder]="'i18n_af_placeholderEnterFullName' | translate"
                                       [formControl]="form.controls.prosecutorFullName">
                                @if (form.controls.prosecutorFullName.hasError('required')) {
                                    <mat-error class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }

                    @if (form.controls.officerJobTitle) {
                        <div fxLayout="column" fxLayoutAlign="start start"
                             class="min-max-w-400">
                            <div
                                class="t5 c-primary-gray-600">{{ 'i18n_af_labelOfficerJobTitle' | translate }} {{
                                    form.controls.officerJobTitle.hasValidator(Validators.required) ? '*' : ''
                                }}
                            </div>
                            <mat-form-field class="w-100 mt-4">
                                <input matInput
                                       [placeholder]="'i18n_af_placeholderEnterJobTitle' | translate"
                                       [formControl]="form.controls.officerJobTitle">
                                @if (form.controls.officerJobTitle.hasError('required')) {
                                    <mat-error class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }

                    @if (form.controls.officerFullName) {
                        <div fxLayout="column" fxLayoutAlign="start start"
                             class="min-max-w-400">
                            <div
                                class="t5 c-primary-gray-600">{{ 'i18n_af_labelOfficerFullName' | translate }} {{
                                    form.controls.officerFullName.hasValidator(Validators.required) ? '*' : ''
                                }}
                            </div>
                            <mat-form-field class="w-100 mt-4">
                                <input matInput
                                       [placeholder]="'i18n_af_placeholderEnterFullName' | translate"
                                       [formControl]="form.controls.officerFullName">
                                @if (form.controls.officerFullName.hasError('required')) {
                                    <mat-error class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }
                </div>

                @if (form.controls.description) {
                    <div fxLayout="column" fxLayoutAlign="start start" class="w-100 mt-40">
                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelRefundDescription' | translate }}*</div>
                        <mat-form-field class="mt-4 w-100"
                                        [class.value-not-empty]="form.enabled && form.value.description">
                <textarea matInput
                          #descriptionArea
                          [maxlength]="DESCRIPTION_MAX_LENGTH"
                          class="resize-none large pt-12 pb-12"
                          [placeholder]="'i18n_af_placeholderRefundDescription' | translate"
                          formControlName="description"></textarea>
                            <mat-hint align="start" class="t5 c-primary-gray-600">{{ descriptionArea.value.length }}
                                / {{ DESCRIPTION_MAX_LENGTH }}
                            </mat-hint>
                        </mat-form-field>
                    </div>
                }
            }
            @if (form.controls.attachments) {
                <af-files class="w-824"
                          [class.mt-40]="!isProcessingBySender"
                          [maxFileCount]="MAX_FILES_COUNT"
                          label="i18n_af_labelDocumentType"
                          [form]="form.controls.attachments"
                          [bucket]="BucketName.REFUND_FILES"
                          [filterDictionaryBy]="filterDictionaryBy"
                          [excludeFromDictionary]="excludeAttachmentTypesFromDictionary"/>
            }
            @if (!isProcessingBySender) {
                <div fxLayout="row" fxLayoutAlign="start center" class="mt-40">
                    <ui-kit-button spinnerId="submit"
                                   [label]="'i18n_af_buttonNext' | translate"/>
                    <ui-kit-button class="ml-16"
                                   color="accent"
                                   buttonType="button"
                                   type="text"
                                   (clickListener)="cancel.emit()"
                                   [label]="'i18n_af_buttonCancel' | translate"/>
                </div>
            }
        </form>
    }
</ng-template>
